/**
 * Polls users/{uid} after sign-up and sets name via updateUserName when onUserCreated lags.
 */
import { type Firestore, doc, getDoc } from 'firebase/firestore';
import { type Functions } from 'firebase/functions';
import { callUpdateUserName } from '@/helpers/moderation/updateUserName';

export async function syncSignupNameToFirestore(
  db: Firestore,
  funcs: Functions,
  uid: string,
  name: string,
) {
  for (let i = 0; i < 15; i++) {
    const snap = await getDoc(doc(db, 'users', uid));
    if (snap.exists()) {
      const current = snap.data()?.name as string | undefined;
      if (!current?.trim()) {
        await callUpdateUserName(funcs, name);
      }
      return;
    }
    await new Promise((r) => setTimeout(r, 300));
  }
}
